export default "__VITE_ASSET__IAuyL4X7__"